module.exports = {"140471400":"长治高新技术开发区城北街街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140471.json
// module id = 393
// module chunks = 0